import { DEFAULT_COVER_IMG, DEFAULT_TITLE } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

export interface PdpParams {
  externalId: string;
  abTest?: string;
  searchPosition?: string;
  searchQueryId?: string;
  sortBy?: string;
}
interface PdpOptions extends PdpParams, RouteOptions {}

/**
 * @returns '{ route: /displate/123?abTest=ab&searchPosition=sp&searchQueryId=sqi&sortBy=sby target: elysium | 'external}'
 */
export const RouteToProductPage = (options: PdpOptions) => {
  const builtQuery = options.query ?? {};
  if (options.abTest) {
    builtQuery.abTest = options.abTest;
  }
  if (options.searchPosition) {
    builtQuery.searchPosition = options.searchPosition;
  }
  if (options.searchQueryId) {
    builtQuery.searchQueryId = options.searchQueryId;
  }
  if (options.sortBy) {
    builtQuery.sortBy = options.sortBy;
  }

  return RouteBuilder({
    path: `/displate/${options.externalId}`,
    target: 'elysium',
    query: builtQuery,
    ...options,
  });
};

export const ProductPageConfig: PageConfig = {
  readableName: 'Regular PDP',
  analyticsGaName: 'product',
  analyticsAthenaName: 'artwork',
  pagePathnames: ['/displate/[externalId]'],
  displayPromoBar: true,
  defaultMeta: {
    title: DEFAULT_TITLE,
    description: '',
    coverImage: DEFAULT_COVER_IMG,
  },
};
